"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palermo": {
    "d54cb6e2": [{
      "hkey": "ca18980e",
      "slug": "boccadifalco-borgonuovo-bellolampo",
      "name": "Boccadifalco, Borgonuovo, Bellolampo",
      "primary": true,
      "skipSearch": false
    }],
    "boccadifalco-borgnonuovo-bellolampo": [{
      "hkey": "ca18980e",
      "slug": "boccadifalco-borgonuovo-bellolampo",
      "name": "Boccadifalco, Borgonuovo, Bellolampo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;